module.exports = __webpack_public_path__ + "img/242733_333A4D_3E4554_3C3B43-256px.1e05c9c6.png";